import { useMedplum } from '@medplum/react';

export function AccessDenied() {
  const medplum = useMedplum();

  const handleSignOut = async () => {
    await medplum.signOut();
    window.location.href = '/signin';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-primary)]">
      <div className="card p-8 max-w-md text-center">
        <h1 className="text-2xl font-semibold text-gray-200 mb-4">
          Patient Access Only
        </h1>
        <p className="text-gray-400 mb-6">
          This application is designed for patient onboarding.
          Provider and staff access is not currently supported.
        </p>
        <button
          onClick={handleSignOut}
          className="btn"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
